export default function transformToTitleCase(string) {
  if (string.trim().length > 0) {
    const words = string.split(' ');
    return words.map((word) => word[0].toUpperCase() + word.substring(1)).join(' ');
  }
  return '';
}
